// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './InputQuantity.scss';
import icons from '../../assets/styles/icons.scss';
import classNames from 'classnames/bind';

export type InputQuantityAction = 'more' | 'less';

type Props = {
  +handleChange: (action: InputQuantityAction) => void;
  +quantity: string;
  +className?: { [key: string]: string };
  +disableLess?: boolean;
  +disableMore?: boolean;
};

export default class InputQuantity extends Component<Props, void> {
  static defaultProps = {
    className: {},
  };

  render() {
    const { quantity, handleChange, className, disableLess, disableMore } = this.props;
    return (
      <section className={classNames(style.inputQuantityWrap, className)}>
        <button className={classNames({ [style.disableLess]: disableLess })}
                type="button"
                onClick={() => handleChange('less')}>
          <i className={icons.iconMinusMedium}/>
        </button>
        <label>{quantity}</label>
        <button className={classNames({ [style.disableMore]: disableMore })}
                type="button"
                onClick={() => handleChange('more')}>
          <i className={icons.iconPlusMedium}/>
        </button>
      </section>
    );
  }
}

InputQuantity.propTypes = {
  handleChange: PropTypes.func.isRequired,
  quantity: PropTypes.string.isRequired,
  className: PropTypes.object,
  disableLess: PropTypes.bool,
  disableMore: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/elements/InputQuantity/InputQuantity.jsx